import { apiService } from './apiService';

export const loadingSlotService = {
  async getLoadingSlots(params?: { date?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.date) queryParams.append('date', params.date);

    const query = queryParams.toString();
    return await apiService.get(`/loading-slots${query ? `?${query}` : ''}`);
  },

  async getLoadingSlot(id: string | number) {
    return await apiService.get(`/loading-slots/${id}`);
  },

  async createLoadingSlot(data: any) {
    return await apiService.post('/loading-slots', data);
  },

  async updateLoadingSlot(id: string | number, data: any) {
    return await apiService.put(`/loading-slots/${id}`, data);
  },

  async deleteLoadingSlot(id: string | number) {
    return await apiService.delete(`/loading-slots/${id}`);
  },
};
